import Basepage, { BasePageState } from '../Basepage';
import thankYouImg from './images/super-thank-you-amico.svg';
import React from 'react';

interface PaymentResultState extends BasePageState {
  paymentPendingRefresh: number;
}
interface PaymentResultModel {}

export default class PaymentResultPage extends Basepage<
  PaymentResultState,
  PaymentResultModel
> {
  pendingTimerHandler?: NodeJS.Timer;

  renderChild(): JSX.Element {
    let paymentStatus = this.state.apiData.body.paymentResult;
    switch (paymentStatus) {
      case 'success':
        return (
          <div
            className="thankYou"
            style={{
              marginLeft: 'auto',
              marginRight: 'auto',
              textAlign: 'center',
              alignContent: 'center',
            }}
          >
            <img src={thankYouImg} style={{ height: '200px', width: 'auto' }} />
            <br />
            <span>
              Vielen Dank für Ihre Bestellung.
              <br />
              <br />
              Sie erhalten nun automatisch per Email eine Bestätigung zu Ihrer
              Bestellung.
              <br />
              Sobald Ihre Ware versendet wurde, werden wir Sie wieder per Email
              benachrichtigen und ggfs. Ihre Sendungsnummer mitteilen.
              <br />
              <br />
              Wir freuen uns, dass Sie unser Kunde sind.
            </span>
          </div>
        );

      case 'fail':
        return (
          <div>
            <span>
              Ihre Bestellung ist leider fehlgeschlagen, da ihre Zahlung nicht
              akzeptiert wurde.
            </span>
          </div>
        );

      case 'abort':
        return (
          <div>
            <span>Sie haben Ihre Zahlung abgebrochen.</span>
          </div>
        );

      case 'pending':
        let mailNotify: boolean = this.state.apiData.body.mailNotify;
        if (mailNotify) {
          return (
            <div>
              <span>
                Es tut uns leid, die Bearbeitung der Zahlung dauert länger als
                erwartet. Wir benachrichtigen Sie per Email.
              </span>
            </div>
          );
        } else {
          return (
            <div>
              <span>
                Wir übeprufen gerade Ihre Zahlung, bitte haben Sie einem Moment Geduld.<br/>
                Bitte schliessen Sie das <b>Fenster noch nicht</b>, Ihre Zahlung wird
                noch bearbeitet. Seite aktualesiert in{' '}
                {this.state.paymentPendingRefresh} sekunden.
              </span>
            </div>
          );
        }

      case 'unknow':
      default:
        return (
          <div>
            <span>
              Ihre Bestellung befindet sich in bearbeitung.
              <br />
              Sie werden, sobald ein Fortschritt vorliegt, per E-Mail
              benachrichtig.
            </span>
          </div>
        );
    }
  }
  initState(base: BasePageState): PaymentResultState {
    let pendingTime = 0;
    if (base.apiData?.body?.wait != undefined) {
      pendingTime = base.apiData.body.wait;
    }

    let newState: PaymentResultState = {
      ...base,
      paymentPendingRefresh: pendingTime,
    };
    return newState;
  }

  getApiReqestUrl(checkOnly: boolean): string {
    let anyProps: any = this.props;
    let oneCommand = '';

    if (
      anyProps.location != undefined &&
      anyProps.location.search.includes('paymentType=')
    ) {
      let urlParams = new URLSearchParams(anyProps.location.search);

      let paymentType: string | null = urlParams.get('paymentType');
      let orderId: string | null = urlParams.get('orderGUID');

      if (paymentType != null && orderId != null) {
        let paramsArray = [];
        paramsArray['paymentType'] = paymentType;
        paramsArray['orderGUID'] = orderId;
        if (paymentType == 'PAYPAL') {
          let token: string | null = urlParams.get('token');
          let cancel: string | null = urlParams.get('cancel');
          if (token != null) {
            paramsArray['token'] = token;
          }
          if (cancel != null) {
            paramsArray['cancel'] = cancel;
          }
        }

        oneCommand = '?';
        let paramsKeys = Object.getOwnPropertyNames(paramsArray);
        paramsKeys.shift();
        paramsKeys.sort();

        paramsKeys.map((item, index) => {
          if (index != 0) {
            oneCommand += '&';
          }
          oneCommand += item + '=' + paramsArray[item];
        });

        if (paymentType == 'PAYPAL') {
          let PayerID: string | null = urlParams.get('PayerID');
          if (PayerID != null) {
            oneCommand += '&PayerID=' + PayerID;
          }
        }
      }
    }

    return this.state.apiBase + '/Checkout_VR.php' + oneCommand;
  }
  releaseOneCommand(): void {}
  childDidMount(): void {
    if (this.pendingTimerHandler == null) {
      this.pendingTimerHandler = setInterval(
        () => this.handlerPendigTimer(),
        1000,
      );
    }
  }
  handlerPendigTimer(): void {
    if (this.state.paymentPendingRefresh > 0) {
      let newpaymentPendingRefresh = this.state.paymentPendingRefresh - 1;
      this.setState({
        paymentPendingRefresh: newpaymentPendingRefresh,
      });
      if (newpaymentPendingRefresh == 0) {
        let headers = {
          'Content-Type': 'application/json',
        };

        let url =
          this.getApiReqestUrl(false) +
          '&retry=' +
          (+this.state.apiData.body.retry + 1);
        fetch(url, {
          headers: headers,
          credentials: 'include',
        })
          .then((response) => {
            return response.json();
          })
          .then((data) => {
            this.body = data.body;
            let newState: any = {
              apiData: data,
              hasApiData: true,
              paymentPendingRefresh: data.body.wait,
            };
            this.setState(newState);
          });
      }
    }
  }
  childDidUnmount(): void {
    //throw new Error('Method not implemented.');
  }
  initJSChild(): string {
    return '';
    //throw new Error('Method not implemented.');
  }
  childDidUpdate(prevProp: any, prevState: any): void {
    //throw new Error('Method not implemented.');
  }
  getRightBreadCrumbParts(): JSX.Element {
    return <></>;
  }

  pageHeaderGetter(): string | null {
    return null;
  }
  pageTitleGetter(): string {
    return '';
  }
  getBreadCrumb(): JSX.Element {
    return <span>Zahlung</span>;
  }
  getType(): string {
    return 'PaymentResultPage';
  }
}
